import {canCategorizeCurrentCartAssets} from './canCategorizeCurrentCartAssets';

export const canCategorizeAddCurrentCartAssets = (): boolean =>
	canCategorizeCurrentCartAssets();
